<template>
    <div>
        <Appbar/>
        <HeroBanner/>
        <div class="container">
            <div class="row justify-content-center" v-if="success">
                <div class="col-md-8 my-5">
                    <div class="alert alert-success p-5">
                        <p>Thank you for submitting your Solution Plan with us.</p>
                        <p>Our team will review and if it meets our standard, it will be approved</p>
                         <router-link class="btn btn-danger" to="/challenge">Go to challenges</router-link>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center" v-if="!success">
                 <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12">
                                    <h3 class="text-danger" style="font-size:1.5em; font-style:italic">LEADER'S VISION</h3>
                                </div>
                                <div class="col-12">
                                    <p>
                                        <strong>
                                            Heading :
                                        </strong>
                                        {{currentChallenge.heading}}
                                    </p>
                                    <p>
                                        <strong>
                                            Summary:
                                        </strong>
                                        {{currentChallenge.summary}}
                                    </p>
                                    <hr>
                                </div>
                                <div class="col-12">
                                    <h3 class="text-danger" style="font-size:1.5em; font-style:italic">CRITIQUE</h3>
                                </div>
                                <div class="col-12">
                                      <!-- <p >
                                        <strong>
                                            Heading :
                                        </strong>
                                        {{thinkersCritique && thinkersCritique.heading}}
                                    </p> -->
                                    <p>
                                        <!-- <strong>
                                            Summary:
                                        </strong> -->
                                        {{thinkersCritique && thinkersCritique.summary}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-8 my-2">
                    <h2 style="font-size:1.7em">Add Your Solution Plan</h2>
                    <router-link to="/challenge" class="btn">
                        Back
                    </router-link>
                </div>
            </div>
            <div class="row" v-if="!success">
                <div class="col-sm-2"></div>
                <div class="col-sm-8 py-5">
                    <form action="" @submit.prevent='addPlans'>
                        <div class="form-group">
                                <label for="name">Full Name  <strong class="text-danger">(required)</strong></label>
                                <input type="text" name="name" class="form-control" v-model="name" required>
                            </div>
                             <div class="form-group">
                                    <label for="DOB">Age  <strong class="text-danger">(required)</strong></label>
                                    <input min="0" type="number" required name="DOB" class="form-control" v-model="age">
                            </div>
                             <p class="p-0">Gender <strong class="text-danger">(required)</strong></p>
                                <div class="form-check ml-2">
                                    <input v-model="gender" class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" 
                                    value="Male" checked required>
                                    <label class="form-check-label" for="exampleRadios1">
                                        Male
                                    </label>
                                </div>
                                <div class="form-check ml-2">
                                    <input class="form-check-input" v-model="gender" type="radio" name="exampleRadios" id="exampleRadios2"
                                    value="Female">
                                    <label class="form-check-label" for="exampleRadios2">
                                        Female
                                    </label>
                                </div>
                             <div class="form-group" >
                            <label  for="certification_number">Market <strong class="text-danger">(required)</strong></label>
                               <multiselect 
                                    required
                                    id="sales-markets"
                                    v-model="market_id" deselect-label="Can't remove this value" track-by="id" 
                                    label="name" placeholder="Select Maket" :options="markets" :allow-empty="false" >
                                </multiselect>
                                 </div>
                            <div class="form-group">
                                <label for="heading">Heading <strong class="text-danger">(required)</strong></label>
                                <input type="text" name="Heading" class="form-control" v-model="heading" required>
                            </div>
                        
                            <div class="form-group">
                                <label for="summary">Summary <strong class="text-danger">(optional)</strong></label>
                                <textarea name="summary" class="form-control" rows="15" v-model="summary" required></textarea>
                            </div>
                            <div class="form-group">
                                    <label for="basic-url">Attach PDF <strong class="text-danger">(optional)</strong></label>
                                    <div class="custom-file">
                                    <input accept="application/pdf" type="file" class="custom-file-input" id="validatedCustomFile" @change="uploadPdf" >
                                    <label class="custom-file-label" for="validatedCustomFile">{{pdfTitle ? pdfTitle :"Choose file..."}}</label>
                                    </div>
                            </div>
                            <div class="form-group">
                                        <label for="basic-url">Attach Document  <strong class="text-danger">(optional)</strong></label>
                                    <div class="custom-file">
                                    <input accept=".doc,.docx,"  type="file" class="custom-file-input" id="validatedCustomFile" @change="uploadDoc" >
                                    <label class="custom-file-label" for="validatedCustomFile">
                                        {{docTitle ? docTitle :"Choose file..."}}
                                    </label>
                                    </div>
                            </div>
                        <label for="basic-url">Add Support Video <strong class="text-danger">(optional)</strong></label>
                                <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon3">https://www.youtube.com/</span>
                                </div>
                                <input v-model="video" type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3">
                                </div>
                            <p>
                            Please upload your photo <strong class="text-danger">(optional)</strong>:<br>
                            <input type="file" name="datafile" size="40" accept="image/*" @change="uploadImage">
                            </p>


                          <div class="alert alert-danger" v-if="marketError">
                                 <strong class="" >{{marketError}}</strong>
                        </div>
                            <button type="submit" class="btn myBtn float-right">Submit</button>
                    </form>
                </div>
               
            </div>
        </div>
        <FinalFooter />
     <!-- <Footer/>
     <Partners/> -->
    </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import Appbar from '../appBar'
import HeroBanner from './Header'
// import Footer from '../footer'
// import Partners from '../partners'
import url from '../../helpers/url'
import axios from 'axios'
import toasterMixin from '../../mixins/toasterMinxin'
import FinalFooter from '../../components/FinalFooter'
    export default {
        components:{
            Multiselect,
            Appbar,
            HeroBanner,
            FinalFooter
            // Footer,
            // Partners,
            
        },
        data() {
            return {
                markets:[],
                gender:'',
                issueArea:'',
                name:'',
                pic:'',
                age:'',
                heading:'',
                summary:'',
                market_id:'',
                pdf:'',
                video:'',
                doc:'',
                picTitle:'',
                pdfTitle:'',
                docTitle:'',
                currentChallenge:{},
                country:'',
                organisation:'',
                thinkersCritique:'',
                success:false,
                marketError:null
            }
        },
        methods: {
             uploadImage(event) {
                this.pic = event.target.files
                this.picTitle = this.pic[0].name  
                if(this.pic) {
                    let size
                    for( let i = 0; i < this.pic.length; i++) {
                       size  = Math.round(( this.pic[i].size  / 1024)); 
                    }
                    if( size > 2048) {
                        this.error = true
                        this.toast({
                            message:'Picture Size is too big',
                            type:'error'
                        })
                        return;
                    }
                    
                }  
            },
            uploadDoc() {
                this.doc = event.target.files
                this.docTitle = this.doc[0].name
                if(this.doc) {
                    let size
                    for( let i = 0; i < this.doc.length; i++) {
                       size  = Math.round(( this.doc[i].size  / 1024)); 
                    }
                    if( size > 2048) {
                        this.error = true
                        this.toast({
                            message:'Document Size is too big',
                            type:'error'
                        })
                        return;
                    }
                    
                }  
            },
            uploadPdf() {
                this.pdf = event.target.files
                this.pdfTitle = this.pdf[0].name  
                if(this.pdf) {
                    let size
                    for( let i = 0; i < this.pdf.length; i++) {
                       size  = Math.round(( this.pdf[i].size  / 1024)); 
                    }
                    if( size > 2048) {
                        this.error = true
                        this.toast({
                            message:'PDF Size is too big',
                            type:'error'
                        })
                        return;
                    }
                    
                }  
            },
            addPlans() {
                 if(this.market_id === '') {
                    this.marketError = "Please market is required."
                    return
                } else {
                    this.marketError = ''
                }
              const formData = new FormData()
              formData.append('name', this.name)
              formData.append('age', this.age)
              formData.append('heading', this.heading)
              formData.append('summary', this.summary)
              formData.append('gender', this.gender)
              formData.append('market', this.market_id.id)
              formData.append('video', this.video)
              formData.append('leaders_vision_id', this.$route.params.challengeID)
              formData.append('thinkers_critique_id',this.$route.params.critiqueID)
              if(this.pic) {
                    for( let i = 0; i < this.pic.length; i++) {
                    formData.append('image  ', this.pic[i])
                    }
                }else{
                    formData.append('image','')
                }
               if(this.pdf) {
                    for( let i = 0; i < this.pdf.length; i++) {
                    formData.append('pdf', this.pdf[i])
                    }
               }else{
                   formData.append('pdf','')
               }
               if(this.doc) {
                    for( let i = 0; i < this.doc.length; i++) {
                    formData.append('doc', this.doc[i])
                    }
               }else{
                   formData.append('doc','')
               }
               for (var pair of formData.entries())
                        {
                        console.log(pair[0]+ ', '+ pair[1]); 
                        }

               this.$store.dispatch('addEnterpreneursResponse', formData)
                .then(response => {
                    if(response) {
                        this.success = true
                    }
                }).catch(err => {
                    if(err?.response?.data == undefined) {
                        this.toast({
                            message:'Network error. Check network connection and try again.',
                            type:'error'
                        })
                    }
                })
            }
            
        },
        mounted() {
        document.querySelector('body').setAttribute('style', 'background-color:#f6f6f6')
        axios.get(`${url()}/api/market/`).then( response => {
            this.markets = response.data
        })
         this.$store.dispatch('fetchLeadersVision').then(response => {
                const data = response.data.find( challenge => challenge.id == this.$route.params.challengeID)
                const critique = data.thinkers_critique.find(critique => critique.id == this.$route.params.critiqueID)
                this.currentChallenge = data
                this.thinkersCritique = critique
            })
    },
    beforeDestroy() {
        document.querySelector('body').removeAttribute('style')
    },
    }
</script>
<style  scoped>
input,select, textarea,.custom-file-label, .myBtn{
    background-color:#b62631;
    color: #FFF;
}
h2{
    display:inline;
}
a{
    float:right;
    border:2px solid black;
}
   @media screen and (max-width: 600px) {
       h1 {
           font-size: 1.8em;
           margin-top:50px;
       }
   }
</style>